export const userDropdownStyle = {
  wrap: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    cursor: 'pointer',

    '@media (max-width: 639.98px)': {
      maxWidth: '50vw',
    },
  },
  email: {
    color: 'var(--neutral-300)',

    '@media (max-width: 639.98px)': {
      maxWidth: '50vw',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
  button: {
    background: 'var(--background-grey-op-50-1)',

    '@media (max-width: 639.98px)': {
      display: 'none',
    },
  },
  rotateArrow: {
    transform: 'rotate(180deg)',
  },
  options: {
    width: '220px',
  },
  option: {
    padding: '8px 16px',
    cursor: 'pointer',

    '&:hover': {
      background: 'var(--background-grey-op-50-1)',
    },

    '&:last-child': {
      borderTop: '1px solid var(--neutral-100)',
      color: 'var(--error-500)',
    },
  },

  name: {
    '@media (max-width: 639.98px)': {
      maxWidth: '50vw',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
};
